
pickerTagListController = ($element) ->
    'ngInject'

    @tagPicker = $element.controller('dybTagPicker')

    return


pickerTagListDirective = ->
    'ngInject'

    restrict: 'E'
    templateUrl: 'util/tags/pickerTagList'
    scope: tagGroup: '='
    require: '^dybTagPicker'
    controller: pickerTagListController
    bindToController: true
    controllerAs: 'ctrl'

module.directive 'dybTagpickerTagList', pickerTagListDirective